import { useState } from "react";
import { rankItems, pickItems } from "@/mocks/content";

export default function RankAndPicks() {
  const [view, setView] = useState<"rank" | "picks">("rank");
  const badge = ["冠军", "亚军", "季军"];

  return (
    <section id="rank" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 text-xs font-medium uppercase tracking-widest text-accent-600">Sugar Ranking</p>
            <h2 className="font-display text-3xl text-foreground-950 md:text-5xl">甜蜜糖分榜单</h2>
          </div>
          <div className="inline-flex w-fit items-center gap-1 rounded-full bg-background-200 p-1">
            {([
              { key: "rank", label: "本周榜单" },
              { key: "picks", label: "甜蜜精选" },
            ] as const).map((t) => (
              <button
                key={t.key}
                onClick={() => setView(t.key)}
                className={`whitespace-nowrap cursor-pointer rounded-full px-5 py-2 text-sm transition-colors ${
                  view === t.key ? "bg-white text-primary-600" : "text-foreground-500 hover:text-foreground-700"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        {view === "rank" && (
          <div className="overflow-hidden rounded-2xl border border-background-200 bg-white">
            {rankItems.map((item, i) => (
              <a
                key={item.id}
                href="#guide"
                className={`group flex items-center gap-3 px-4 py-4 transition-colors hover:bg-primary-50 md:gap-6 md:px-6 ${
                  i !== rankItems.length - 1 ? "border-b border-background-100" : ""
                }`}
              >
                <div
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold md:h-11 md:w-11 md:text-base ${
                    i < 3 ? "bg-gradient-to-br from-primary-400 to-accent-400 text-white" : "bg-background-100 text-foreground-400"
                  }`}
                >
                  {i + 1}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-600 md:text-base">
                      {item.title}
                    </h3>
                    {i < 3 && (
                      <span className="whitespace-nowrap rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-700">
                        {badge[i]}
                      </span>
                    )}
                    <span className="whitespace-nowrap rounded-md bg-accent-100 px-2 py-0.5 text-xs text-accent-700">
                      {item.tag}
                    </span>
                  </div>
                  <p className="mt-1 truncate text-xs text-foreground-500 md:text-sm">{item.content}</p>
                </div>
                <div className="hidden shrink-0 items-center gap-1 sm:flex">
                  <span className="font-display text-2xl text-accent-500 md:text-3xl">{item.score}</span>
                  <span className="text-xs text-foreground-400">甜度</span>
                  <i className="ri-arrow-right-line ml-2 text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500"></i>
                </div>
              </a>
            ))}
          </div>
        )}

        {view === "picks" && (
          <div id="picks" className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {pickItems.map((item) => (
              <article
                key={item.id}
                className="group overflow-hidden rounded-2xl border border-background-200 bg-white transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={item.title}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute right-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs text-white">
                    <i className="ri-star-fill mr-1 text-[10px]"></i>
                    {item.tag}
                  </span>
                </div>
                <div className="p-5">
                  <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">{item.category}</span>
                  <h3 className="mt-2 mb-2 text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-600">
                    {item.title}
                  </h3>
                  <p className="mb-4 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                  <div className="flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
                    <span>{item.date}</span>
                    <span className="flex items-center gap-1 text-accent-600">
                      <i className="ri-heart-3-fill text-primary-500"></i>
                      {item.likes}颗糖
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}